import React from 'react'
import Select from 'react-select'

function CustomSelect(props) {
  return (
    <Select
      styles={{
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #d9d9d9',
          backgroundColor: state?.isDisabled
            ? '#f5f5f1'
            : provided?.backgroundColor,
          height: props.controlSize ?? '35px',
          minHeight: props.controlSize ?? '35px',
        }),
      }}
      {...props}
    />
  )
}

export default CustomSelect
